import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import PrensaSection from "@/components/PrensaSection.vue";
import ExpositorSection from "@/components/ExpositorSection.vue";
import FormColegio from "@/components/FormColegio.vue";

const routes = [
  {
    path: "/",
    component: FormSection,
  },
  {
    path: "/expositor",
    component: ExpositorSection,
  },
  {
    path: "/prensa",
    component: PrensaSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/colegios",
    component: FormColegio,
  },
  {
    path: "/finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;